import { Badge } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'

import { Scope } from '../../../../enums/scope'
import { useOrgUsesReceiptsOnly } from '../../../../hooks/useOrgUsesReceiptsOnly'
import { isAuthorized } from '../../../../utils/isAuthorized'
import { AttachmentFilterType } from '../../enums/attachmentFiltertype'
import { useAttachmentsCounter } from '../../hooks/useAttachmentsCounter'
import { getDefaultAttachmentFilterType } from './utils/getDefaultAttachmentFilterType'

interface ReceiptsCountBadgeProps {
  documentFilterType?: AttachmentFilterType
}

export const AttachmentsCountBadge = ({ documentFilterType }: ReceiptsCountBadgeProps): ReactElement | null => {
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()
  const isEInvoicingOnly = useIsEInvoicingOnly()
  const { countMap, isOverLimitMap, isLoading } = useAttachmentsCounter({ enabled: !orgUsesReceiptsOnly })

  if (orgUsesReceiptsOnly) {
    return null
  }

  const isEDocumentReadAuthorized = isAuthorized(Scope.EDocumentRead)
  const defaultFilterType = getDefaultAttachmentFilterType({ isEInvoicingOnly, isEDocumentReadAuthorized })
  const filterType = documentFilterType || defaultFilterType
  const withCounter = countMap[filterType] > 0 && !isLoading

  if (!withCounter) {
    return null
  }

  return (
    <Badge>
      {countMap[filterType]}
      {isOverLimitMap[filterType] ? '+' : ''}
    </Badge>
  )
}
